import {Directive, OnDestroy, OnInit} from '@angular/core';
import {DatePickerComponent} from "@progress/kendo-angular-dateinputs";
import {Subscription} from "rxjs";
import {DateInputFormatPlaceholder} from "@progress/kendo-angular-dateinputs/dist/es2015/dateinput/models/format-placeholder.model";

@Directive({
    selector: '[date-picker-defaults]'
})
export class DatePickerDefaultsDirective implements OnInit, OnDestroy {
    protected subscriptions: Subscription = new Subscription(() => {});

    constructor(private component: DatePickerComponent) {
    }

    public ngOnInit(): void {
        this.component.input.inputElement.type = 'tel';
        this.component.format = 'dd-MM-yyyy';
        this.component.placeholder = '';
        this.component.formatPlaceholder = {year: ' ', month: ' ', day: ' '} as DateInputFormatPlaceholder;

        this.subscriptions.add(this.component.onFocus.subscribe(() => {
            this.component.input.inputElement.setSelectionRange(0, 9999);
        }));
    }

    public ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/fw/directives/date-picker-defaults.directive.ts